import React from 'react';
import classnames from 'classnames';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import cookie from '../lib/cookie';
import giftHero from '../images/1920x600-elYw_Egg-130122.jpg';

const mapStateToProps = (state) => {
    return {
        cartId: state.shoppingCart.cart.id,
        disableNav: state.shoppingCart.disableNav,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        fetchData: ACTIONS_CREATOR.fetchData,
        setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
        setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
        disableNavItems: ACTIONS_CREATOR.disableNavItems,
        setHero: ACTIONS_CREATOR.setHero
    },
    dispatch,
);

class GiftCardPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: null,
            isAddingItem: false,
            success: false
        }
    }

    componentDidMount() {
        this.props.disableNavItems(this.props.disableNav, CONST.SHOPPING_NAV_INDEX, false);
        // get amount
        var amt = parseInt(this.props.amount);
        var closest = CONST.GIFT_CARD_AMOUNTS.reduce(function(prev, curr) {
            return (Math.abs(curr - amt) < Math.abs(prev - amt) ? curr : prev);
        });
        this.setState({amount: closest});
        this.props.setHero("", giftHero);
        // add to cart
        this.setState({isAddingItem: true});
        const url = `/1/cart/${this.props.cartId}/item`;
        const body = {
            type: CONST.ITEM_GIFT_CARD,
            amount: closest,
        };
        this.props.setAlertMessage(true, 'success', 'Adding Gift Voucher to cart...');
        this.props.fetchData(url, 'POST', body)
        .then(result => {
            this.props.setShoppingCart(result);
            cookie.setItem("cartId", `${result.id}`, null, '/');
            this.props.setAlertMessage(false);
            this.setState({isAddingItem: false, success: true});
        })
        .catch(err => {
            err.then( errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({isAddingItem: false});
        });
    }

    render() {
        return (
            <div className="product-page mb-5">
                <h1 className="aui-headline-3 mb-4">${this.state.amount} {CONST.GIFT_CARD_NAME}</h1>
                {this.state.success && <p>This item has been added to your cart.</p>}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardPage);
